import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { openFundPreview } from '@capital-access/common/actions';
import { CompositeId } from '@capital-access/profiles/common';
import { Fund, SearchCategory } from '../../../+state/models';
import { SearchItemsListBaseComponent } from '../search-items-list-base-component/search-items-list-base.component';

@Component({
  selector: 'ca-search-funds-list',
  templateUrl: './search-funds-list.component.html',
  styleUrls: ['./../search-list.common.scss'],
  standalone: false
})
export class SearchFundsListComponent extends SearchItemsListBaseComponent<Fund> {
  constructor(store: Store) {
    super(store, SearchCategory.Funds);
  }

  openProfilePreview(fund: Fund) {
    const { crmId, prospectingId: prId } = fund;
    this.store.dispatch(openFundPreview({ id: { prId, crmId } }));
  }

  trackByMethod(index: number, item: Fund): string {
    const compositeId = new CompositeId(item.prospectingId, item.crmId);
    return compositeId.toString();
  }
}
